import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
  editButton: {
    minWidth: 0,
  },
  editIcon: {
    fontSize: '1em',
    color: theme.palette.facet.primaryGray,
  },
}));

const EditButton = ({ onClick }) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.editButton}
      onClick={onClick}
    >
      <EditIcon size="small" className={classes.editIcon} />
    </Button>
  );
};

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default EditButton;
